import {useEffect, useState} from "react";
// TODO: Remove this hook
const MOBILE_MAX_WIDTH_PX = 768;

function getIsMobileViewport(): boolean {
    if (typeof window === "undefined") {
        return false;
    }
    return window.innerWidth < MOBILE_MAX_WIDTH_PX;
}

export function useCheckMobile(): boolean {
    const [isMobile, setIsMobile] = useState<boolean>(getIsMobileViewport);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < MOBILE_MAX_WIDTH_PX);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);
    return isMobile;
}
